import { apiSend } from "@/api/apicommon";

export default {
    async getRefMedication() {
        const method = "GET";
        const endpoint = "/clinical/refMedication";
        return apiSend(method, endpoint);
    },
    async getRefLuMedication() {
        const method = "GET";
        const endpoint = "/clinical/refLuMedication";
        return apiSend(method, endpoint);
    },
    async getRefLuDosage() {
        const method = "GET";
        const endpoint = "/clinical/refLuDosage";
        return apiSend(method, endpoint);
    },
    async getRefAdministrationRoutes() {
        const method = "GET";
        const endpoint = "/clinical/refAdministrationRoutes";
        return apiSend(method, endpoint);
    }
};
